import { render, staticRenderFns } from "./TrendingOffer.vue?vue&type=template&id=196efd5d&"
import script from "./TrendingOffer.vue?vue&type=script&lang=js&"
export * from "./TrendingOffer.vue?vue&type=script&lang=js&"
import style0 from "./TrendingOffer.vue?vue&type=style&index=0&id=196efd5d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports